export default "__VITE_ASSET__Bs1oO1iF__"